const messages = {
    'zh-CN': {
      mainTitle: 'AI-Coach: 下一代智能陪练系统',
      subTitle: 'AI-Coach – 革命性企业培训解决方案',
      desc: '融合最新大语言模型与情感化数字人技术,集成10大核心模块,为企业打造沉浸式、个性化、数据驱动的员工技能训练平台。支持实时面部识别防作弊、多维度智能评分、个性化数字人角色库、AI自动搭课等前沿功能。现在预约演示,即可获得专属企业定制方案与7天免费试用。',
      freeTrial: '立即免费体验',
      demo: '观看产品演示',
      aiCoach: 'AI 智能对练',
      product: '产品优势',
      scene: '应用场景',
      case: '客户案例',
      contact: '联系我们',
      hotline: '全国热线：',
      login: '登录',
      bookDemo: '预约演示',
  
      // 首页-背景与挑战
      trainingDifficulty: '传统企业培训耗时费力，效果难以量化，无法满足快',
      trainingDifficulty2: '节奏的业务发展需求。',
      trainingDifficulty3: '新员工培养周期长，销售及客服团队的对话技巧和服务',
      trainingDifficulty4: '水平参差不齐，直接影响客户体验与业绩增长。',
      trainingDifficulty5: '高昂的培训成本与人员流失率，尤其在服务密集型行业，',
      trainingDifficulty6: '成为企业持续发展的痛点。',
  
      arkCoachDesc: 'ARK Coach 是一款基于AI的沉浸式智能对话练习平台，彻底改变企业员工培训模式。我们运用前沿的大语言模型（LLM）、生成式AI及多模态交互技术，高度仿真各类真实业务对话情境。赋能销售、客服等一线员工，通过实战模拟快速掌握沟通精髓，迅速成长为业务能手，实现“入职即专家”的目标。平台提供覆盖多行业的“开箱即用”标准化课程，并支持企业定制专属练习场景，确保培训内容与业务紧密结合。',
  
      sixCoreAbilities: '六大核心能力',
      reconstructProfessionalPath: 'ARK Coach集成了最先进的人工智能技术，融合DataAgent智能评估、情感化数字人交互、AI自动搭课、多维度智能评分、大模型剧本引擎、数据驱动洞察，为企业打造涵盖智能评估、个性化训练、实时反馈、数据分析的完整AI陪练体系',
      ultraRealisticAiTraining: 'DataAgent智能评估系统',
      arkCoachDesc2: '基于最新大语言模型，支持标准话术评分、专业知识评分、服务能力评分、自定义评分等多维度评估，提供精准改进建议。系统能够实时分析语言表达、逻辑结构、情绪状态、回应策略等多个维度，确保AI评分准确性。',
      experienceNow: '立即体验',
      dynamicCustomerPortrait: '情感化数字人交互',
      dynamicCustomerPortraitDesc: '支持数字人形象外观库（性别、年龄、形象）、口唇驱动、个性化语音配置、角色库管理，创造真实、沉浸式的对话体验。超真实表情与个性化语音合成，创造沉浸体验，增强学习效果。',
      realTimeEmotionInsight: 'AI自动搭课系统',
      realTimeEmotionInsightDesc: '支持练习模式、考核模式、固定话术训练、任务模拟训练、产品演示操作模拟训练，按岗位/组织/群组灵活发布。基于企业知识库，智能生成个性化训练内容，实现培训内容零等待部署。',
      instantIntelligentScoring: '多维度智能评分',
      instantIntelligentScoringDesc: '支持语音流畅度、清晰度、亲和力、说服力、语言表达能力评分，支持企业自定义评分维度和标准，确保AI评分准确性。系统提供量化评分与改进建议，用户可立即查看表现分析报告。',
      scientificCapabilityModel: '大模型剧本引擎',
      scientificCapabilityModelDesc: '支持人工剧本配置、AI生成剧本、大模型剧本配置，包含客户画像配置、训练框架配置、必经环节配置等，实现自然流畅的陪练体验。',
      immersiveMultimodalInteraction: '数据驱动洞察',
      arkCoachDesc3: '支持训练记录查阅、训练评价查阅、训练评分查阅，提供积分管理、权限管理、资源库管理，为企业决策提供数据支持。通过持续反馈与跟踪，打造真正可衡量、可成长的沟通能力进阶之路。',
      fiveStepsToEnhanceDialogueAbility: '5步高效提升对话能力',
      chooseIndustryScene: '选择行业/场景',
      aiCustomerSimulationTraining: 'AI客户模拟对练',
      realTimeEmotionAndAbilityFeedback: '实时情绪与能力反馈',
      abilityModelAnalysisReport: '能力模型分析报告',
      continuousOptimizationGrowth: '持续优化成长',
      applicationScenarios: '应用场景',
      goldenSalesQuickening: '金牌销售速成',
      goldenSalesQuickeningDesc: '汽车、房产、金融等高客单价行业销售新人培训，快速掌握逼单、异议处理等核心技巧。',
      excellentCustomerService: '卓越客服打造',
      excellentCustomerServiceDesc: '电信、电商、高端消费品等行业客服团队赋能，提升问题解决效率与客户沟通温度。',
      newEmployeeStandardization: '新员工入职标准化',
      newEmployeeStandardizationDesc: '连锁零售、餐饮等行业大规模新员工onboarding，快速统一服务标准与品牌形象。',
      productKnowledgeAndMarketingScriptPractice: '产品知识与营销话术演练',
      productKnowledgeAndMarketingScriptPracticeDesc: '新产品上市、复杂业务介绍等场景的强化训练，确保信息传递准确高效。',
      highPotentialTalentAbilityAdvancement: '高潜人才能力进阶',
      highPotentialTalentAbilityAdvancementDesc: '针对储备干部或核心骨干，进行高阶沟通与谈判技巧的专项提升。',
      moreIndustryCustomization: '更多行业定制',
      moreIndustryCustomizationDesc: '支持多行业专属定制，满足企业多样化培训需求。',
      trustedEnterpriseAlTrainingPlatform: '值得信赖的企业级 Al 训练平台',
      buildEfficientTeamWithArkCoach: '与 ARK Coach 共建高效团队，迈向行业领先',
      trainingCycleShortening: '培训效率提升',
      newEmployeeOnboardingTimeAverageShortening: '相比传统培训方法，AI陪练让员工技能掌握速度提升3倍，快速适应岗位需求',
      trainingCostReduction: '训练完成率',
      trainingCostAverageReduction: '游戏化学习体验和个性化反馈让员工更愿意参与培训，显著提高完成率',
      businessConversionEnhancement: '成本节约',
      businessConversionRateAverageIncrease: '减少讲师、场地和差旅费用，同时提高培训效果，实现真正的降本增效',
      preciseOrganizationAbilityOptimization: '技能达标时间缩短',
      arkCoachAfterUse: '自适应学习路径和即时反馈机制让员工更快达到岗位技能要求',
      keyAbilityBreakthrough90: '实时面部识别、眼神识别、切屏监控确保训练过程真实有效',
      comprehensiveCustomerExperienceImprovement: '防作弊准确率',
      professionalAndStandardizedServiceDialogue: '支持语音流畅度、清晰度、亲和力、说服力等多维度智能评分',
      employeeContinuousGrowth: '评分维度',
      employeeDiscoveryOfCognitiveBlindSpots: '帮助企业决策提供数据支持，实现真正的降本增效',
      comparedToTraditionalMethods: '相较传统方式提升培训效率',
      salesConversionRateEnhancement: '销售转化率提升',
      keyAbilityEnhancementRate: '关键能力提升率',
      readyToUpgradeYourTeam: '准备好改变您的培训方式了吗？',
      twoSteps: '立即体验ARK-Coach智能陪练系统，集成10大核心模块',
      steps: '',
      aiIntelligentDialogueTraining: '，利用最新大语言模型、情感化数字人、防作弊管理、多维度智能评分、个性化数字人角色库等前沿技术，为企业培训带来革命性变革',
      helpYourTeamEfficientGrowth: '免费开始试用',
      backgroundAndChallenges: '背景与挑战',
      coreConcepts: '核心理念',
      businessCooperation: '商务合作：business@emotibot.com',
      channelCooperation: '渠道合作：',
      joinUs: '加入我们：',
      technicalSupport: '技术支持：ecc@emotibot.com',
      
      // 新增高级功能模块
      advancedFeatures: '企业级高级功能',
      antiCheatManagement: '防作弊管理系统',
      antiCheatDesc: '实时面部识别与眼神识别，支持实时抓拍与摄像头录制，限制训练时长与切屏监控，确保训练过程真实有效',
      intelligentVoiceProcessing: '智能语音处理',
      voiceProcessingDesc: '高精度ASR语音识别，支持语音输入与手动修改，重新语音输入功能，语音识别响应速度快',
      personalizedPermissionManagement: '个性化权限管理',
      permissionManagementDesc: '管理员功能权限个性化配置，数据权限精细化控制，学员权限灵活设置，按组织设置数字人权限',
      enterpriseSecurity: '企业级安全',
      enterpriseSecurityDesc: '私有化/混合云灵活部署，权限/审计/加密齐备，兼容现有系统',
      
      // 现代化功能标签
      limitedOffer: '限时优惠',
      featureTag1: '300%提效',
      featureTag2: '50% 降本', 
      featureTag3: '防作弊',
      featureTag4: '多维度评分',
      featureTag5: '数字人角色库',
      featureTag6: 'AI自动搭课',
    },
    'zh-TW': {
      mainTitle: 'AI-Coach: 下一代智能陪練系統',
      subTitle: 'AI-Coach – 革命性企業培訓解決方案',
      desc: '融合最新大語言模型與情感化數字人技術,集成10大核心模塊,為企業打造沉浸式、個性化、數據驅動的員工技能訓練平台。支持實時面部識別防作弊、多維度智能評分、個性化數字人角色庫、AI自動搭課等前沿功能。現在預約演示,即可獲得專屬企業定制方案與7天免費試用。',
      freeTrial: '立即免費體驗',
      demo: '觀看產品演示',
      aiCoach: 'AI 智能對練',
      product: '產品優勢',
      scene: '應用場景',
      case: '客戶案例',
      contact: '聯絡我們',
      hotline: '全國熱線：',
      login: '登入',
      bookDemo: '預約演示',
      trainingDifficulty: '傳統企業培訓耗時費力，效果難以量化，無法滿足快',
      trainingDifficulty2: '節奏的業務發展需求。',
      trainingDifficulty3: '新員工培養週期長，銷售及客服團隊的對話技巧和服務',
      trainingDifficulty4: '水準參差不齊，直接影響客戶體驗與業績增長。',
      trainingDifficulty5: '高昂的培訓成本與人員流失率，尤其在服務密集型行業，',
      trainingDifficulty6: '成為企業持續發展的痛點。',
      arkCoachDesc: 'ARK Coach 是一款基於AI的沉浸式智能對話練習平台，徹底改變企業員工培訓模式。我們運用前沿的大語言模型（LLM）、生成式AI及多模態交互技術，高度仿真各類真實業務對話情境。賦能銷售、客服等一線員工，通過實戰模擬快速掌握溝通精髓，迅速成長為業務能手，實現「入職即專家」的目標。平台提供覆蓋多行業的「開箱即用」標準化課程，並支持企業定制專屬練習場景，確保培訓內容與業務緊密結合。',
      sixCoreAbilities: '六大核心能力',
      reconstructProfessionalPath: 'ARK Coach集成了最先進的人工智能技術，融合DataAgent智能評估、情感化數字人交互、AI自動搭課、多維度智能評分、大模型劇本引擎、數據驅動洞察六大核心能力，為企業打造涵蓋智能評估、個性化訓練、實時反饋、數據分析的完整AI陪練體系',
      ultraRealisticAiTraining: '超高擬真AI對練',
      arkCoachDesc2: 'Ark Coach 借助先進的大語言模型與角色扮演式 Agent 技術，打造高度擬真的對話體驗。虛擬客戶具備行業知識、行為邏輯與情緒反應，能夠真實模擬客戶的提問、猶豫、反對與成交信號。用戶彷彿在與真實客戶交流，在不斷演練中提升應變能力、說服技巧與情境判斷力。通過高頻、可信、可控的模擬對練，讓每一次訓練都像一場實戰，為銷售與服務人員打造真正的「AI 實戰陪練官」。',
      experienceNow: '立即體驗',
      dynamicCustomerPortrait: '動態客戶畫像博弈',
      dynamicCustomerPortraitDesc: '即時調整對話風格與反應策略，模擬不同類型客戶的行為模式與挑戰場景。銷售代表在訓練中不僅練語言，更鍛鍊策略判斷與應變能力，逐步掌握從初次接觸到成交的完整客戶溝通路徑。讓陪練不再是靜態流程，而是貼近實戰的智能演練。',
      realTimeEmotionInsight: '即時情緒洞察與引導',
      realTimeEmotionInsightDesc: '搭載先進的語音與語言情緒識別技術，能夠在對練過程中即時識別銷售人員與虛擬客戶的情緒變化，如緊張、遲疑、自信或抗拒。系統不僅能做出動態回應，還會在對話後給出情緒波動分析與引導建議，幫助用戶優化表達方式、情緒管理與共情技巧。真正做到讓「話術訓練」進化為「情緒覺察 + 溝通引導」的綜合能力提升。',
      instantIntelligentScoring: '即時智能評分與診斷',
      instantIntelligentScoringDesc: '利用多模態 AI 引擎，對每一次練習進行即時評分與精準診斷。系統會根據語言表達、邏輯結構、情緒狀態、回應策略等多個維度，提供量化評分與改進建議。訓練結束後，用戶可立即查看表現分析報告，了解優勢與待優化項，並獲得個性化提升路徑。通過持續反饋與跟蹤，打造真正可衡量、可成長的溝通能力進階之路。',
      scientificCapabilityModel: '科學能力模型構建',
      scientificCapabilityModelDesc: '基於科學化的人才能力框架，構建多維度能力模型，涵蓋表達力、說服力、共情力、應變力、結構化溝通等核心指標。每一次對練都被系統映射到能力畫像中，動態追蹤成長曲線。企業可以按需定義能力標準，系統自動匹配崗位要求與員工表現，實現從訓練到評估、從差距診斷到精準培養的閉環管理。',
      immersiveMultimodalInteraction: '沉浸式多模態互動',
      arkCoachDesc3: 'Ark Coach 打破傳統文本或音頻訓練的單一形式，融合語音識別（ASR）、語音合成（TTS）、人臉識別、表情分析與自然語言理解，實現真正沉浸式的多模態人機對練體驗。支持Web與App多端訓練模式，用戶可以通過語音、表情、語調與虛擬客戶進行即時互動，就像面對真人一樣。系統能夠精準識別用戶的語速、語氣變化和非語言信號，並即時反饋，大幅提升學習沉浸感與訓練真實感，幫助用戶快速適應真實職場溝通場景。',
      fiveStepsToEnhanceDialogueAbility: '5步高效提升對話能力',
      chooseIndustryScene: '選擇行業/場景',
      aiCustomerSimulationTraining: 'AI客戶模擬對練',
      realTimeEmotionAndAbilityFeedback: '即時情緒與能力反饋',
      abilityModelAnalysisReport: '能力模型分析報告',
      continuousOptimizationGrowth: '持續優化成長',
      applicationScenarios: '應用場景',
      goldenSalesQuickening: '金牌銷售速成',
      goldenSalesQuickeningDesc: '汽車、房產、金融等高客單價行業銷售新人培訓，快速掌握逼單、異議處理等核心技巧。',
      excellentCustomerService: '卓越客服打造',
      excellentCustomerServiceDesc: '電信、電商、高端消費品等行業客服團隊賦能，提升問題解決效率與客戶溝通溫度。',
      newEmployeeStandardization: '新員工入職標準化',
      newEmployeeStandardizationDesc: '連鎖零售、餐飲等行業大規模新員工onboarding，快速統一服務標準與品牌形象。',
      productKnowledgeAndMarketingScriptPractice: '產品知識與行銷話術演練',
      productKnowledgeAndMarketingScriptPracticeDesc: '新產品上市、複雜業務介紹等場景的強化訓練，確保信息傳遞準確高效。',
      highPotentialTalentAbilityAdvancement: '高潛人才能力進階',
      highPotentialTalentAbilityAdvancementDesc: '針對儲備幹部或核心骨幹，進行高階溝通與談判技巧的專項提升。',
      moreIndustryCustomization: '更多行業定制',
      moreIndustryCustomizationDesc: '支持多行業專屬定制，滿足企業多樣化培訓需求。',
      trustedEnterpriseAlTrainingPlatform: '值得信賴的企業級 Al 訓練平台',
      buildEfficientTeamWithArkCoach: '與 ARK Coach 共建高效團隊，邁向行業領先',
      trainingCycleShortening: '大幅縮短培訓週期',
      newEmployeeOnboardingTimeAverageShortening: '新員工上崗時間平均縮短 50%，快速投入實際工作，提升團隊整體效能。',
      trainingCostReduction: '顯著降低培訓成本',
      trainingCostAverageReduction: '培訓支出平均降低 40%，實現降本增效，優化企業資源配置。',
      businessConversionEnhancement: '有效提升業務轉化',
      businessConversionRateAverageIncrease: '關鍵業務指標（如銷售轉化率、客單價）平均提升 15%-20% 以上。',
      preciseOrganizationAbilityOptimization: '精準優化組織能力',
      arkCoachAfterUse: '企業實測表明，使用 ARK Coach 後，',
      keyAbilityBreakthrough90: '員工平均在4週內實現關鍵能力突破90%',
      comprehensiveCustomerExperienceImprovement: '全面改善客戶體驗',
      professionalAndStandardizedServiceDialogue: '專業、高效、標準化的服務對話，用戶滿意度達95%，提升客戶品牌忠誠度。',
      employeeContinuousGrowth: '驅動員工持續成長',
      employeeDiscoveryOfCognitiveBlindSpots: '幫助員工發現認知盲區與技能短板，激發自主學習動力，提升職業幸福感。',
      comparedToTraditionalMethods: '相較傳統方式提升培訓效率',
      salesConversionRateEnhancement: '銷售轉化率提升',
      keyAbilityEnhancementRate: '關鍵能力提升率',
      readyToUpgradeYourTeam: '準備好升級你的團隊了嗎？',
      twoSteps: '僅需',
      steps: '步，即可開啟',
      aiIntelligentDialogueTraining: 'AI 智能對話對練之旅，',
      helpYourTeamEfficientGrowth: '助力團隊高效成長！',
      backgroundAndChallenges: '背景與挑戰',
      coreConcepts: '核心理念',
      businessCooperation: '商務合作：business@emotibot.com',
      channelCooperation: '渠道合作：',
      joinUs: '加入我們：',
      technicalSupport: '技術支持：ecc@emotibot.com',
      
      // 現代化功能標籤
      limitedOffer: '限時優惠',
      featureTag1: '300%提效',
      featureTag2: '50% 降本',
      featureTag3: '防作弊',
      featureTag4: '多維度評分',
      featureTag5: '數字人角色庫',
      featureTag6: 'AI自動搭課',
    },
    'en': {
      mainTitle: "AI-Coach: Next-Generation Intelligent Training System",
      subTitle: "AI-Coach – Revolutionary Enterprise Training Solution",
      desc: "Integrates the latest large language models and emotional digital human technology, integrating 10 core modules, to create an immersive, personalized, data-driven employee skill training platform for enterprises. Supports real-time facial recognition anti-cheating, multi-dimensional intelligent scoring, personalized digital human role library, AI automatic course arrangement and other cutting-edge functions. Book a demo now to get an exclusive enterprise customized solution and 7-day free trial.",
      freeTrial: "Free Trial",
      demo: "View",
      aiCoach: "AI Coach",
      product: "Product Advantages",
      scene: "Application Scenarios",
      case: "Customer Cases",
      contact: "Contact Us",
      hotline: "Hotline: ",
      login: "Login",
      bookDemo: "Book a Demo",
      trainingDifficulty: "Traditional corporate training is time-consuming and inefficient, with results hard to quantify, unable to meet the fast",
      trainingDifficulty2: "pace of business development.",
      trainingDifficulty3: "New employee training cycles are long, and sales/service teams have uneven skills,",
      trainingDifficulty4: "directly affecting customer experience and business growth.",
      trainingDifficulty5: "High training costs and staff turnover, especially in service-intensive industries,",
      trainingDifficulty6: "have become pain points for sustainable business development.",
      arkCoachDesc: "ARK Coach is an AI-based immersive intelligent conversation practice platform that revolutionizes corporate training. We use cutting-edge LLM, generative AI, and multimodal interaction to highly simulate real business conversations. Empower sales and service staff to quickly master communication skills through practical simulation, rapidly grow into business experts, and achieve 'expert from day one'. The platform provides standardized courses for multiple industries and supports custom practice scenarios to ensure training content is closely integrated with business.",
      sixCoreAbilities: "Six Core Capabilities, Comprehensive Coverage of Enterprise Training Needs",
      reconstructProfessionalPath: "ARK Coach integrates cutting-edge AI technology, combining six core capabilities: DataAgent intelligent assessment, emotional digital human interaction, AI auto-course creation, multi-dimensional intelligent scoring, large language model script engine, and data-driven insights, creating a complete AI coaching system covering intelligent assessment, personalized training, real-time feedback, and data analysis",
      ultraRealisticAiTraining: "Ultra-Realistic AI Training",
      arkCoachDesc2: "ARK Coach leverages advanced LLM and role-playing Agent technology to create highly realistic conversation experiences. Virtual customers possess industry knowledge, behavioral logic, and emotional responses, truly simulating customer questions, hesitations, objections, and buying signals. Users feel like they are communicating with real customers, improving adaptability, persuasion, and situational judgment through repeated practice. High-frequency, reliable, and controllable simulations make every training session like a real battle, providing a true 'AI sparring partner' for sales and service staff.",
      experienceNow: "Experience Now",
      dynamicCustomerPortrait: "Dynamic Customer Profiling",
      dynamicCustomerPortraitDesc: "Adjust conversation style and response strategies in real time, simulating different customer behaviors and challenge scenarios. Sales reps not only practice language but also hone strategic judgment and adaptability, gradually mastering the full customer communication path from first contact to deal. Training is no longer a static process, but an intelligent simulation close to real business.",
      realTimeEmotionInsight: "Real-Time Emotion Insight & Guidance",
      realTimeEmotionInsightDesc: "With advanced speech and language emotion recognition, the system can identify emotional changes in both sales staff and virtual customers during training, such as nervousness, hesitation, confidence, or resistance. The system not only responds dynamically but also provides emotional analysis and guidance after the conversation, helping users optimize expression, emotional management, and empathy skills. This truly upgrades 'script training' to 'emotional awareness + communication guidance'.",
      instantIntelligentScoring: "Instant Intelligent Scoring & Diagnosis",
      instantIntelligentScoringDesc: "Using a multimodal AI engine, each practice is scored and diagnosed in real time. The system provides quantitative scores and improvement suggestions based on language, logic, emotion, response strategy, and more. After training, users can immediately view performance analysis reports, understand strengths and areas for improvement, and receive personalized growth paths. Continuous feedback and tracking create a truly measurable and improvable communication skill journey.",
      scientificCapabilityModel: "Scientific Capability Model Building",
      scientificCapabilityModelDesc: "Based on a scientific talent framework, a multi-dimensional capability model is built, covering expression, persuasion, empathy, adaptability, structured communication, and more. Each practice is mapped to a capability profile, dynamically tracking growth. Companies can define standards as needed, and the system automatically matches job requirements and employee performance, achieving closed-loop management from training to evaluation, gap diagnosis to targeted development.",
      immersiveMultimodalInteraction: "Immersive Multimodal Interaction",
      arkCoachDesc3: "ARK Coach breaks the single form of traditional text or audio training, integrating ASR, TTS, facial recognition, expression analysis, and natural language understanding to create a truly immersive multimodal human-machine practice experience. Supports web and app multi-terminal training. Users can interact with virtual customers in real time via voice, expressions, and intonation, just like facing a real person. The system accurately recognizes speech rate, tone changes, and non-verbal signals, providing instant feedback to greatly enhance immersion and realism, helping users quickly adapt to real workplace communication.",
      fiveStepsToEnhanceDialogueAbility: "5 Steps to Efficiently Improve Dialogue Skills",
      chooseIndustryScene: "Choose Industry/Scenario",
      aiCustomerSimulationTraining: "AI Customer Simulation Training",
      realTimeEmotionAndAbilityFeedback: "Real-Time Emotion & Ability Feedback",
      abilityModelAnalysisReport: "Ability Model Analysis Report",
      continuousOptimizationGrowth: "Continuous Optimization & Growth",
      applicationScenarios: "Application Scenarios",
      goldenSalesQuickening: "Rapid Sales Training",
      goldenSalesQuickeningDesc: "Quickly master core skills such as closing and objection handling for new sales staff in high-value industries like automotive, real estate, and finance.",
      excellentCustomerService: "Excellent Customer Service",
      excellentCustomerServiceDesc: "Empower customer service teams in telecom, e-commerce, and high-end consumer goods to improve problem-solving efficiency and customer communication.",
      newEmployeeStandardization: "Standardized Onboarding",
      newEmployeeStandardizationDesc: "Large-scale onboarding for new employees in retail and catering, quickly unifying service standards and brand image.",
      productKnowledgeAndMarketingScriptPractice: "Product Knowledge & Marketing Script Practice",
      productKnowledgeAndMarketingScriptPracticeDesc: "Intensive training for new product launches and complex business introductions to ensure accurate and efficient information delivery.",
      highPotentialTalentAbilityAdvancement: "High-Potential Talent Advancement",
      highPotentialTalentAbilityAdvancementDesc: "Specialized training for reserve cadres or key staff to improve advanced communication and negotiation skills.",
      moreIndustryCustomization: "More Industry Customization",
      moreIndustryCustomizationDesc: "Supports exclusive customization for multiple industries to meet diverse corporate training needs.",
      trustedEnterpriseAlTrainingPlatform: "Trusted Enterprise AI Training Platform",
      buildEfficientTeamWithArkCoach: "Build an efficient team with ARK Coach and lead the industry",
      trainingCycleShortening: "Significantly Shorten Training Cycle",
      newEmployeeOnboardingTimeAverageShortening: "Average onboarding time for new employees reduced by 50%, quickly integrating into work and improving team efficiency.",
      trainingCostReduction: "Significantly Reduce Training Costs",
      trainingCostAverageReduction: "Training expenses reduced by 40% on average, achieving cost reduction and efficiency improvement.",
      businessConversionEnhancement: "Effectively Improve Business Conversion",
      businessConversionRateAverageIncrease: "Key business indicators (such as sales conversion rate, customer unit price) increased by 15%-20% on average.",
      preciseOrganizationAbilityOptimization: "Precisely Optimize Organizational Capability",
      arkCoachAfterUse: "Corporate tests show that after using ARK Coach,",
      keyAbilityBreakthrough90: "employees achieve a 90% breakthrough in key abilities within 4 weeks on average.",
      comprehensiveCustomerExperienceImprovement: "Comprehensively Improve Customer Experience",
      professionalAndStandardizedServiceDialogue: "Professional, efficient, and standardized service dialogue, with user satisfaction reaching 95% and improved brand loyalty.",
      employeeContinuousGrowth: "Drive Continuous Employee Growth",
      employeeDiscoveryOfCognitiveBlindSpots: "Help employees discover cognitive blind spots and skill gaps, stimulate self-learning motivation, and improve career happiness.",
      comparedToTraditionalMethods: "Improved Training Efficiency Compared to Traditional Methods",
      salesConversionRateEnhancement: "Sales Conversion Rate Improvement",
      keyAbilityEnhancementRate: "Key Ability Improvement Rate",
      readyToUpgradeYourTeam: "Ready to upgrade your team?",
      twoSteps: "Only",
      steps: "steps to start",
      aiIntelligentDialogueTraining: "AI intelligent conversation training journey,",
      helpYourTeamEfficientGrowth: "help your team grow efficiently!",
      backgroundAndChallenges: "Background & Challenges",
      coreConcepts: "Core Concepts",
      businessCooperation: "Business Cooperation: business@emotibot.com",
      channelCooperation: "Channel Cooperation:",
      joinUs: "Join Us:",
      technicalSupport: "Technical Support: ecc@emotibot.com",
      
      // Modern Feature Tags
      limitedOffer: 'Limited Time Offer',
      featureTag1: '300% Efficiency',
      featureTag2: '50% Cost Reduction',
      featureTag3: 'Anti-Cheating',
      featureTag4: 'Multi-Dimensional Scoring',
      featureTag5: 'Digital Human Role Library',
      featureTag6: 'AI Auto Course Arrangement',
    }
  };
export default messages;